import { useParams } from '@tanstack/react-router'

export const useBranchId = () => {
    const { id } = useParams({ from: '/_tablet-layout/branch/$id' })

    return id
}
